







































import { Component, Vue, Watch } from "vue-property-decorator";
import ContentHeader from "@/components/ContentHeader.vue";
import { IReportPage } from "@/contentful/models";
import AppStorage from "@/appStorage";
import * as Contentful from "contentful";
import { ContentfulClientApi } from "contentful";
import { Document } from "@contentful/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

@Component({
  components: {
    ContentHeader,
  },
  metaInfo: {
    title: "Medlemssidorna - Protokoll",
  },
})
export default class Reports extends Vue {
  reportPage: IReportPage | null = null;
  public loading = true;
  public storage: AppStorage = Vue.AppStorage;
  public content: IReportPage | null = null;
  contentfulClient: ContentfulClientApi = Contentful.createClient({
    space: this.storage.contentfulSpace,
    accessToken: this.storage.contentfulAccessToken,
  });
  @Watch("$route.params.id")
  onIdChange(): void {
    this.loadPage();
  }

  htmlToString(document: Document): string {
    return documentToHtmlString(document);
  }

  mounted(): void {
    this.loadPage();
  }

  loadPage(): void {
    if (this.$route.params.id) {
      const cachedContent: IReportPage | undefined = Vue.AppStorage.reportPage.find((item: IReportPage) => {
        return item.sys.id === this.$route.params.id;
      });
      if (cachedContent) {
        this.content = cachedContent;
        this.loading = false;
      } else {
        window.setTimeout(() => {
          this.contentfulClient
            .getEntry(this.$route.params.id)
            .then((response: any) => {
              this.loading = false;
              this.content = response;
              Vue.AppStorage.reportPage.push(this.content);
            })
            .catch(() => {
              this.$router.push({ path: "/404" });
            });
        }, 500);
      }
    }
  }
}
